import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { REPORTING_BASE_V2 } from '../reporting-base-v2.token';
import { REPORTING_BASE } from '../reporting-base.token';
import { API_BASE } from '../api-base.token';
import { ReportRequest } from './report-request';
import { ReportResponse } from './report-response';
import { ReportStatusResponse } from './report-status-response';
import { ReportResponseV2 } from './report-response-v2';

@Injectable({
  providedIn: 'root',
})
export class ReportingHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(REPORTING_BASE)
    private readonly reportingBase: string,
    @Inject(REPORTING_BASE_V2)
    private readonly reportingBaseV2: string,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  generatePdf(reportRequest: ReportRequest) {
    const url = Location.joinWithSlash(
      this.reportingBase,
      'ReportOrchestrator_HttpStart'
    );

    return this.httpClient.post<ReportResponse>(url, reportRequest);
  }

  generateJson(reportRequest: ReportRequest) {
    const url = Location.joinWithSlash(
      this.reportingBase,
      'JsonReportOrchestrator_HttpStart'
    );

    return this.httpClient.post<ReportResponse>(url, reportRequest);
  }

  getStatus(statusUri: string) {
    return this.httpClient.get<ReportStatusResponse>(statusUri);
  }

  generatePdfV2(reportRequest: ReportRequest) {
    const url = Location.joinWithSlash(
      this.reportingBaseV2,
      'api/InspectionPdfReporter'
    );

    return this.httpClient.post<ReportResponseV2>(url, reportRequest);
  }

  generateJsonV2(reportRequest: ReportRequest) {
    const url = Location.joinWithSlash(
      this.reportingBaseV2,
      'api/InspectionJsonReporter'
    );

    return this.httpClient.post<ReportResponseV2>(url, reportRequest);
  }

  generatePdfV3(reportRequest: ReportRequest) {
    const url = Location.joinWithSlash(this.apiBase, 'reports/pdf');

    return this.httpClient.post<ReportResponseV2>(url, reportRequest);
  }

  generateJsonV3(reportRequest: ReportRequest) {
    const url = Location.joinWithSlash(this.apiBase, 'reports/json');

    return this.httpClient.post<ReportResponseV2>(url, reportRequest);
  }
}
